import React, { CSSProperties } from 'react';
import { BiLoaderAlt } from 'react-icons/bi';
//
import styles from './loading-circle.module.css';

interface LoadingCircleProps {
  style?: CSSProperties;
}

export default function LoadingCircle({ style }: LoadingCircleProps) {
  return <BiLoaderAlt className={styles['loader']} style={{ ...style }} />;
}
